import { render } from "./PasswordChangeModal.vue?vue&type=template&id=0ce99ee8"
import script from "./PasswordChangeModal.vue?vue&type=script&lang=js"
export * from "./PasswordChangeModal.vue?vue&type=script&lang=js"

import "./PasswordChangeModal.vue?vue&type=style&index=0&id=0ce99ee8&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__